export function ModulFApplicationStyles({ colors }) {
    return {
        input: {
            boxShadow: `0 0 0 1px ${colors.graphicSecondaryColorDark}`,
            focusBoxShadow: `0 0 0 2px ${colors.interaction.focus.color}`
        }
    };
}
